/** Copyright © 2013-2024 DataYes, All Rights Reserved. */

import { Suspense, useState, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import GlobalHeader from 'components/global-header-login/header';
import { showLoginModal } from 'components/global-header-login/login-register';
import Loader from 'components/loader';
import { GlobalStyle } from 'styles/global';
import storage from 'utils/localstorage';
import user from 'utils/user';
import PartnerAuth from 'pages/partner/auth';
import MenuList from './components/menu-list';
import Routes from './routes';
import { StylePageBase } from './style';

const AppRouter = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [userInfo, setInfo] = useState<Record<string, string>>({});
  const isPartner = storage.get('isPartner');

  useEffect(() => {
    user.init().then((resp) => {
      if (resp?.anonymousUser) {
        showLoginModal();
      }
      setInfo(resp);
      setIsLogin(!resp?.anonymousUser);
    });
  }, []);

  return (
    <>
      {!isPartner && <GlobalHeader userInfo={userInfo} />}
      <StylePageBase>
        <GlobalStyle />
        <MenuList />
        {isLogin && (
          <div className="content">
            <Suspense fallback={<Loader />}>
              <Routes />
            </Suspense>
          </div>
        )}
      </StylePageBase>
    </>
  );
};

// 为了将中台以iframe的形式嵌入到友商的系统中，并采取静默登录方案
const PartnerAuthAppRouter = () => (
  <Switch>
    {/* 此路由给申港使用 */}
    <Route path="/partner/auth" component={PartnerAuth} exact />
    {/* 后续对接使用下面的路由 */}
    <Route path="/thirdparty/oauth" component={PartnerAuth} exact />
    <Route path="/" component={AppRouter} />
  </Switch>
);

export default PartnerAuthAppRouter;
